// extracted by mini-css-extract-plugin
export default {"wrapper":"sy-z","viewport":"ty-z","container":"uy-z","slide":"vy-z"};